import { Content, Root, Trigger } from './dropdown';

export { createDropdownSelect } from './dropdown-select';

export const Dropdown = { Root, Trigger, Content };
